import { useDispatch } from 'react-redux';

import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';

import './ResolutionRequest.css';

//data sets with a requestable document. the document name values are whitelisted by the api
export const docNameByDataSet = {
	dobViolations: 'DOB Violation Resolution',
	jobApplications: 'Job Application Drawing',
	dobJobApplications: 'Job Application Drawing',
	ecbViolations: 'ECB Violation Resolution',
	fdnyViolations: 'FDNY Active Violation Order Resolution',
	fdnyNov: 'FDNY Notice of Violation Resolution',
	fdnyVio: 'FDNY Active Violation Order Resolution',
	// fdnyPermits: 'FDNY Permit',
	fdnyPermits2: 'FDNY Permit',
	hpdHousingViolations: 'HPD Housing Violation Resolution',
	housingLitigations: 'HPD Housing Litigation Resolution',
	repairVacateOrders: 'HPD Order to Repair/Vacate Resolution',
	citypayTickets: 'CityPay Ticket Resolution',

	dobViolationsCombined: 'DOB Violation Resolution',
	ecbViolationsCombined: 'ECB Violation Resolution',
	jobApplicationsCombined: 'Job Application Drawing',
	dobSafetyViolations: 'DOB Safety Violation Resolution',
	stopWorkOrders: 'Stop Work Orders',
	elevatorRecords: 'Elevator Records',
	limitedAlterationApplications: 'Job Application Drawing',
	acrisDocuments: 'ACRIS Document',
	acrisSalesTransfers: 'ACRIS Sales and Transfer',
	ecbTicketFinderHearings: 'OATH/ECB Hearing Resolution',
	oathHearingsCombined: 'OATH/ECB Hearing Resolution',
	fdnyOathHearings: 'OATH/ECB Hearing Resolution',
};

//these dataSets should show the request button even if the row isn't "open"
const showOnNonOpen = [
	'jobApplications',
	'dobJobApplications',
	'repairVacateOrders',
	'citypayTickets',

	'dobViolationsCombined', //these are here temporary, api hasn't implemented isOpen flag, TODO: REMOVE!
	'ecbViolationsCombined', //these are here temporary, api hasn't implemented isOpen flag, TODO: REMOVE!
	'jobApplicationsCombined',
	'stopWorkOrders',
	'elevatorRecords',
	'limitedAlterationApplications',
	'acrisDocuments',
	'acrisSalesTransfers',
];

function ResolutionRequest(props) {
	const dispatch = useDispatch();
	const { rowData, dataSet, dataSource } = props;

	let documentName = docNameByDataSet[dataSet];
	let extra = '';
	// The row's record number, sent with the request for the n8n resolution webhook (VWA-2910)
	let itemNumber = null;
	let text = 'Resolve';
	let modalType = MODAL_TYPES.DOCUMENT_REQUEST;

	if (!documentName) {
		return null;
	}

	if (
		(!rowData?.isOpen && !showOnNonOpen.includes(dataSet)) ||
		rowData?.status === 'RESOLVED'
	) {
		return 'Resolved';
	}

	if (dataSet === 'jobApplications' && dataSource === 'OPEN_DATA') {
		itemNumber = rowData?.job__;
		extra = `Job Application ID ${rowData?.job__}`;
		text = 'Request';
		modalType = MODAL_TYPES.ADD_TO_CART;
	} else if (dataSet === 'jobApplications' && dataSource === 'BIS') {
		itemNumber = rowData?.job_number;
		extra = `Job Application ID ${rowData?.job_number}`;
		text = 'Request';
		modalType = MODAL_TYPES.ADD_TO_CART;
	} else if (dataSet === 'dobJobApplications') {
		itemNumber = rowData?.job_filing_number || rowData?.job_number;
		extra = `Job Application Filing ${rowData?.job_filing_number || rowData?.job_number || '[filing number missing]'}`;
		text = 'Request';
		modalType = MODAL_TYPES.ADD_TO_CART;
	} else if (dataSet === 'dobViolations') {
		itemNumber = rowData?.dob_violation_number || rowData?.number;
		extra = `Violation Number: ${rowData?.dob_violation_number || rowData?.number || '[Violation number missing]'}`;
	} else if (dataSet === 'ecbViolations') {
		itemNumber = rowData?.ecb_violation_number;
		extra = `Violation Number: ${rowData?.ecb_violation_number || '[Violation number missing]'}`;
	} else if (dataSet === 'fdnyViolations') {
		itemNumber = rowData?.violation_num;
		extra = `Violation Number: ${rowData?.violation_num || '[Violation number missing]'}`;
	} else if (dataSet === 'fdnyNov') {
		itemNumber = rowData?.summons;
		extra = `Summons Number: ${rowData?.summons || '[Summons number missing]'}`;
	} else if (dataSet === 'fdnyVio') {
		itemNumber = rowData?.order_number;
		extra = `Order Number: ${rowData?.order_number || '[Order number missing]'}`;
	} else if (dataSet === 'fdnyPermits2') {
		itemNumber = rowData?.account_number;
		extra = `Account Number: ${rowData?.account_number || '[Account number missing]'}`;
	} else if (dataSet === 'hpdHousingViolations') {
		itemNumber = rowData?.violationid;
		extra = `Violation Number: ${rowData?.violationid || '[Violation number missing]'}`;
	} else if (dataSet === 'housingLitigations') {
		itemNumber = rowData?.litigationid;
		extra = `Litigation ID: ${rowData?.litigationid || '[Litigation ID missing]'}`;
	} else if (dataSet === 'repairVacateOrders') {
		itemNumber = rowData?.vacate_order_number;
		extra = `Vacate Number: ${rowData?.vacate_order_number || '[Vacate number missing]'}`;
	} else if (dataSet === 'citypayTickets') {
		itemNumber = rowData?.ticketNumber;
		extra = `Ticket Number: ${rowData?.ticketNumber || '[Ticket number missing]'}`;
	} else if (dataSet === 'dobViolationsCombined') {
		itemNumber = rowData?.bisViolationNumber || rowData?.odViolationNumber;
		extra = `Violation Number (Open Data): ${rowData?.odViolationNumber || '[Open Data violation number missing]'}. Violation Number (BIS): ${rowData?.bisViolationNumber || '[BIS violation number missing]'}`;
	} else if (dataSet === 'ecbViolationsCombined') {
		itemNumber = rowData?.bisEcbViolationNumber || rowData?.odEcbViolationNumber;
		extra = `Violation Number (Open Data): ${rowData?.odEcbViolationNumber || '[Open Data violation number missing]'}. Violation Number (BIS): ${rowData?.bisEcbViolationNumber || '[BIS violation number missing]'}`;
	} else if (dataSet === 'jobApplicationsCombined') {
		itemNumber = rowData?.bisJobNumber || rowData?.odJobNumber;
		extra = `Job number (Open Data): ${rowData?.odJobNumber || '[Open Data job number missing]'}. Job number (BIS): ${rowData?.bisJobNumber || '[BIS job number missing]'}`;
		text = 'Request';
		modalType = MODAL_TYPES.ADD_TO_CART;
	} else if (dataSet === 'dobSafetyViolations') {
		itemNumber = rowData?.violation_number;
		extra = `Violation Number: ${rowData?.violation_number || '[Violation number missing]'}`;
	} else if (dataSet === 'limitedAlterationApplications') {
		itemNumber = rowData?.job_number;
		extra = `Job Application ID ${rowData?.job_number}`;
		text = 'Request';
		modalType = MODAL_TYPES.ADD_TO_CART;
	} else if (dataSet === 'stopWorkOrders') {
		itemNumber = rowData?.complaint_number;
		extra = `Stop Work Order Number: ${rowData?.complaint_number || '[Stop Work Order number missing]'}`;
	} else if (dataSet === 'elevatorRecords') {
		itemNumber = rowData?.device_number;
		extra = `Device Number: ${rowData?.device_number || '[Device number missing]'}`;
	} else if (dataSet === 'acrisDocuments') {
		itemNumber = rowData?.document_id;
		extra = `Document ID: ${rowData?.document_id || '[Document ID missing]'}`;
		text = 'Request';
	} else if (dataSet === 'acrisSalesTransfers') {
		itemNumber = rowData?.document_id;
		extra = `Document ID: ${rowData?.document_id || '[Document ID missing]'}`;
		text = 'Request';
	} else if (dataSet === 'ecbTicketFinderHearings') {
		itemNumber = rowData?.violation_no;
		extra = `Summons/Notice Number: ${rowData?.violation_no || '[Summons/Notice number missing]'}`;
	} else if (dataSet === 'fdnyOathHearings') {
		itemNumber = rowData?.ticket_number;
		extra = `Summons/Notice Number: ${rowData?.ticket_number || '[Summons/Notice number missing]'}`;
	} else if (dataSet === 'oathHearingsCombined') {
		itemNumber = rowData?.etfViolationNo || rowData?.odTicketNumber;
		extra = `Summons/Notice Number: ${rowData?.etfViolationNo || rowData?.odTicketNumber || '[Summons/Notice number missing]'}`;
	} else {
		return null;
	}

	const onClick = () =>
		dispatch(openModal(modalType, { documentName, extra, dataSet, itemNumber: itemNumber ? String(itemNumber) : null }));
	return (
		<button
			className="btn btn-success data-table-resolution-request-button"
			onClick={onClick}
		>
			{text}
		</button>
	);
}

export default ResolutionRequest;
